export const _LOAD_MODEL_COMPANY_ = 'Load:Company';
export const _LOAD_MODEL_MESSAGE_ = 'Load:Message';
export const _LOAD_MODEL_SETTING_ = 'Load:Setting';
export const _LOAD_MODEL_RESULTS_ = 'Load:Results';
export const _LOAD_MODEL_VALIDATION_ = 'Load:Validation';
export const _LOAD_MODEL_RISK_CLASSIFICATIONS_ = 'Load:RiskClassifications';

export const COMPANY = {
  city: '',
  cnpj: '',
  site: '',
  state: '',
  email: '',
  number: '',
  address: '',
  zipcode: '',
  district: '',
  whatsapp1: '',
  whatsapp2: '',
  instagram: '',
};

export const MESSAGES = {
  footer: '',
  slogan: '',
  receipt: '',
  warranty: '',
  approbation: '',
  sendMessage: '',
  sendMessageWhats: '',
  sendMessageNewFilesUpload: '',
};

export const SETTINGS = {
  logo: null,
  warranty: null,
  timeAlert: null,
};

export const OPTION = { id: null, slug: null, name: '' };

export const PERMISSION = {
  module_id: null,
  name: null,
  description: null,
  slug: null,
  active: true,
};

export const RISK_ROWS = {
  risk1: { type: 'max-only', placeholder: 'baixo' },
  risk2: { type: 'range', placeholder: 'médio' },
  risk3: { type: 'range', placeholder: 'médio-alto' },
  risk4: { type: 'min-only', placeholder: 'alto' },
};

export const OPTION_FIELDS = [
  { label: 'Meio de dispersão', model: 'dispersal' },
];

export const OPTION_FIELDS_NOISE = [
  { label: 'Avaliação pessoal do trabalhador sobre exposição', model: 'avaliation' },
  { label: 'Tipo de exposição Justicativa', model: 'justify' },
];

export const RISK = {
  min: null,
  max: null,
  color: '',
  conclusion: '',
};

export const DEFAULT_OPTIONS = {
  dispersal: [{ ...OPTION }],
};

export const DEFAULT_OPTIONS_NOISE = {
  avaliation: [{ ...OPTION }],
  justify: [{ ...OPTION }],
};

export const CHEMICAL = {
  risks: {
    risk1: { ...RISK },
    risk2: { ...RISK },
    risk3: { ...RISK },
    risk4: { ...RISK },
  },
  lq: {
    color: '',
    conclusion: '',
  },
  options: {
    ...DEFAULT_OPTIONS,
  },
};

export const NOISE_LEVELS = {
  level1: {
    dailyDoseMin: null,
    dailyDoseMax: null,
    max: null,
    technicalConsiderations: null,
    recommendedAction: null,
    bgColor: null,
  },
  level2: {
    dailyDoseMin: null,
    dailyDoseMax: null,
    min: null,
    max: null,
    technicalConsiderations: null,
    recommendedAction: null,
    bgColor: null,
  },
  level3: {
    dailyDoseMin: null,
    dailyDoseMax: null,
    min: null,
    max: null,
    technicalConsiderations: null,
    recommendedAction: null,
    bgColor: null,
  },
  level4: {
    dailyDoseMin: null,
    min: null,
    technicalConsiderations: null,
    recommendedAction: null,
    bgColor: null,
  },
};

export const RISK_CLASSIFICATION_NHO09 = {
  criteria: ['AREN'],
  levels: {
    level1: {
      min: { AREN: null },
      max: { AREN: null },
      technicalConsideration: null,
      recommendedAction: null,
      bgColor: null,
    },
    level2: {
      min: { AREN: null },
      max: { AREN: null },
      technicalConsideration: null,
      recommendedAction: null,
      bgColor: null,
    },
    level3: {
      min: { AREN: null },
      max: { AREN: null },
      technicalConsideration: null,
      recommendedAction: null,
      bgColor: null,
    },
    level4: {
      operator: '>',
      min: { AREN: null },
      technicalConsideration: null,
      recommendedAction: null,
      bgColor: null,
    },
  },
};

export const RISK_CLASSIFICATION_NHO10 = {
  criteria: ['AREN', 'VDVR'],
  levels: {
    level1: {
      min: { AREN: null, VDVR: null },
      max: { AREN: null, VDVR: null },
      technicalConsideration: null,
      recommendedAction: null,
      bgColor: null,
    },
    level2: {
      min: { AREN: null, VDVR: null },
      max: { AREN: null, VDVR: null },
      technicalConsideration: null,
      recommendedAction: null,
      bgColor: null,
    },
    level3: {
      min: { AREN: null, VDVR: null },
      max: { AREN: null, VDVR: null },
      technicalConsideration: null,
      recommendedAction: null,
      bgColor: null,
    },
    level4: {
      operator: '>',
      min: { AREN: null, VDVR: null },
      technicalConsideration: null,
      recommendedAction: null,
      bgColor: null,
    },
  },
};

export const NOISE = {
  nho: { ...NOISE_LEVELS },
  nr15: { ...NOISE_LEVELS },
};

export const RISK_CLASSIFICATION = {
  nho09: { ...RISK_CLASSIFICATION_NHO09 },
  nho10: { ...RISK_CLASSIFICATION_NHO10 },
};

export const RESULTS = {
  chemical: { ...CHEMICAL },
  noise: { ...NOISE },
};

export const RISK_CLASSIFICATIONS = {
  vibration: { ...RISK_CLASSIFICATION },
};

export const MEASUREMENT_VALIDATION = {
  noise: {
    options: {
      ...DEFAULT_OPTIONS_NOISE,
    },
  },
};
